import { ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core';

@Component({
    selector: 'ca-toggle-item',
    templateUrl: './toggle-item.component.html',
    styleUrl: './toggle-item.component.scss',
    host: {
        '[attr.role]': '"tab"'
    },
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToggleItemComponent {
    selected = signal<boolean>(false);
    value = input<any>();
    select = output<any>();
}
